/**
 * Single source of truth for subscription tier constants (frontend mirror).
 */

export type TierKey = 'free_trial' | 'starter' | 'growth' | 'pro' | 'business' | 'enterprise';

export const TIER_ORDER: Record<string, number> = {
  free_trial: 0,
  starter: 1,
  growth: 2,
  pro: 3,
  business: 4,
  enterprise: 5,
};

const LEGACY_TIER_MAP: Record<string, TierKey> = {
  solo: 'starter',
  solo_dealer: 'business',
  enterprise_dealer: 'enterprise',
  dealer: 'business',
  professional: 'pro',
};

export function normalizeTier(tier: string | undefined | null): TierKey {
  if (!tier) return 'free_trial';
  if (tier in LEGACY_TIER_MAP) return LEGACY_TIER_MAP[tier];
  return tier as TierKey;
}

export const TIER_DISPLAY_NAMES: Record<TierKey, string> = {
  free_trial: 'Free Trial',
  starter: 'Starter',
  growth: 'Growth',
  pro: 'Pro',
  business: 'Business',
  enterprise: 'Enterprise',
};

export function getTierDisplayName(tier: string | undefined | null): string {
  const normalized = normalizeTier(tier);
  return TIER_DISPLAY_NAMES[normalized] || 'Free Trial';
}

export const AI_BG_TIERS = new Set<TierKey>(['growth', 'pro', 'business', 'enterprise']);
export const CLEANUP_TIERS = new Set<TierKey>(['growth', 'pro', 'business', 'enterprise']);

export function hasAiAccess(tier: string | undefined | null): boolean {
  return AI_BG_TIERS.has(normalizeTier(tier));
}

export function hasCleanupAccess(tier: string | undefined | null): boolean {
  return CLEANUP_TIERS.has(normalizeTier(tier));
}

export const SAVED_BATCH_LIMITS: Record<TierKey, number> = {
  free_trial: 0,
  starter: 0,
  growth: 10,
  pro: 30,
  business: Infinity,
  enterprise: Infinity,
};

export function getSavedBatchLimit(tier: string | undefined | null): number {
  return SAVED_BATCH_LIMITS[normalizeTier(tier)] ?? 0;
}
